import React from "react";
import { isMobile } from "react-device-detect";

import CommonLawResultsMobile from "./CommonLawResultsMobile";
import CommonLawResultsDesktop from "./CommonLawResultsDesktop";

function CommonLawResults(props) {
  return isMobile ? <CommonLawResultsMobile {...props} /> : <CommonLawResultsDesktop {...props} />;
}

export default CommonLawResults;
